import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useLocation } from "react-router-dom";
import { baseURL } from "../../config";

const ReportTable = () => {
  const [posts, setPosts] = useState({ reports: [] });
  const [filteredPosts, setFilteredPosts] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(20);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [trainingassigneeToDelete, setTrainingassigneeToDelete] =
    useState(null);
  const [viewTrainningassignee, setTrainningAssigne] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [reportTitle, setReportTitle] = useState("");
  const location = useLocation();
  let path = location.pathname;

  // for pagination -start
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageGroupStart, setPageGroupStart] = useState(1);

  const pagesPerGroup = 10;

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);

    setPageGroupStart(
      Math.floor((pageNumber - 1) / pagesPerGroup) * pagesPerGroup + 1
    );

    fetchPostList(pageNumber);
  };

  // Calculate which pages to show
  const currentPageNumbers = Array.from(
    { length: Math.min(pagesPerGroup, totalPageCount - pageGroupStart + 1) },
    (_, i) => pageGroupStart + i
  );

  const handleNextGroup = () => {
    const nextGroupStart = pageGroupStart + pagesPerGroup;
    if (nextGroupStart <= totalPageCount) {
      setPageGroupStart(nextGroupStart);
      setCurrentPage(nextGroupStart);
      fetchPostList(nextGroupStart); // fetch new page
    }
  };

  const handlePrevGroup = () => {
    const prevGroupStart = pageGroupStart - pagesPerGroup;
    if (prevGroupStart > 0) {
      setPageGroupStart(prevGroupStart);
      setCurrentPage(prevGroupStart);
      fetchPostList(prevGroupStart); // fetch new page
    }
  };

  // for pagination - end

  const fetchPostList = async (pageNo = 1) => {
    try {
      let strReportAPIpath = `${baseURL}/allreports`;

      if (path === "/reports") {
        strReportAPIpath = `${baseURL}/allreports`;
        setReportTitle("Master Employee Score");
      }
      if (path === "/kpireports") {
        strReportAPIpath = `${baseURL}/kpireports?page=${pageNo}&limit=20`;
        setReportTitle("KPI");
      }
      if (path === "/kpioverall") {
        strReportAPIpath = `${baseURL}/kpimaster?page=${pageNo}&limit=20`;
        setReportTitle("KPI Overall");
      }
      if (path === "/reappraisal") {
        strReportAPIpath = `${baseURL}/reappraisal`;
        setReportTitle("Re-Appraisal");
      }
      if (path === "/pipdev") {
        strReportAPIpath = `${baseURL}/pipdev`;
        setReportTitle("PIP Development");
      }
      if (path === "/awardsreport") {
        strReportAPIpath = `${baseURL}/awardsreport`;
        setReportTitle("Awards");
      }
      const { data } = await axios(strReportAPIpath);
      console.log("Fetched data:", data);
      if (Array.isArray(data.reports)) {
        setPosts({ reports: data.reports });
        setFilteredPosts(data.reports);

        if (path === "/kpireports" || path === "/kpioverall") {
          setTotalPageCount(data.totalPages);
          setCurrentPage(data.page);

          window.scrollTo(0, 0);
        }
      } else {
        console.error("Data is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  useEffect(() => {
    fetchPostList();
  }, []);

  useEffect(() => {
    const filterStartDate = startDate ? new Date(startDate) : null;
    const filterEndDate = endDate ? new Date(endDate) : null;

    const filtered = posts.reports.filter((report) => {
      const reportStartDate = new Date(report.AppraisalStartDate);
      const reportEndDate = new Date(report.AppraisalEndDate);

      const withinDateRange =
        (!filterStartDate || reportStartDate >= filterStartDate) &&
        (!filterEndDate || reportEndDate <= filterEndDate);

      const employeeName = report.EmployeeName || "";
      const matchesSearchTerm =
        !searchTerm ||
        report.EmployeeID.includes(searchTerm) ||
        employeeName.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesDepartment =
        !selectedDepartment ||
        report.Department.toLowerCase().includes(
          selectedDepartment.toLowerCase()
        );

      const matchesStatus =
        !selectedStatus || report.AppraisalStatus === selectedStatus;

      return (
        withinDateRange &&
        matchesSearchTerm &&
        matchesDepartment &&
        matchesStatus
      );
    });

    setFilteredPosts(filtered);
  }, [
    startDate,
    endDate,
    searchTerm,
    selectedDepartment,
    selectedStatus,
    posts.reports,
  ]);

  const handleDelete = async (trainingassigneeId) => {
    try {
      setTrainingassigneeToDelete(trainingassigneeId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting training:", error);
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(
        `${baseURL}/deletetrainingassignee?id=${trainingassigneeToDelete}`
      );
      const updatedTrainingassignee = posts.trainingassignee.filter(
        (trainingassignee) => trainingassignee.id !== trainingassigneeToDelete
      );
      setPosts({ trainingassignee: updatedTrainingassignee });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting Training:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleView = (reports) => {
    setTrainningAssigne(reports);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const formatDate = (dateString) => {
    if (dateString) {
      const options = { day: "2-digit", month: "long", year: "numeric" };
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", options);
    } else {
      return "";
    }
  };

  // const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);

    const downloadAllExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredPosts);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Master Employee Score Report");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "Master_Employee_Score_Report.xlsx"
    );
  };

  const downloadToExcel = async () => {
    let APIpath = `${baseURL}/kpimaster_for_export`;

    try {
      if (path === "/kpioverall") {
        APIpath = `${baseURL}/kpimaster_for_export`;
        setReportTitle("Awards");
      } else if (path === "/kpireports") {
        APIpath = `${baseURL}/kpireports_for_export`;
      }
      const { data } = await axios(APIpath);
      console.log("Fetched data:", data);

      const ws = XLSX.utils.json_to_sheet(data.reports);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Master Employee Score Report");
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Master_Employee_Score_Report.xlsx"
      );
    } catch (error) {
      console.log("error when data downloading");
    }
  };

  const downloadPdf = (report) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Report Details", 10, 10);

    const columns = ["Field", "Value"];
    const rows = Object.entries(report).map(([key, value]) => [key, value]);

    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
      margin: { top: 20 },
      theme: "striped",
    });

    doc.save(`report_${report.EmployeeID}.pdf`);
  };

  if (path === "/reports")
    return (
      <div className="pb-3">
        <h4 className="text-start">{reportTitle} Report</h4>
        <div className="col-lg-12 d-flex mt-2 pb-3">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="form-control-my"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="form-control-my"
          />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search by Employee ID or Name"
            className="form-control-my"
          />
        </div>

        <div className="col-lg-12 d-flex justify-content-end">
          <input
            type="text"
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            placeholder="Search by Department"
            className="form-control-my"
          />
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="form-control-my p-1"
          >
            <option value="">All Appraisal Statuses</option>
            {Array.from(
              new Set(posts.reports.map((report) => report.AppraisalStatus))
            ).map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
          <ReactBootstrap.Button
            variant=""
            className="ml-2 p-0 w-25 bg-danger text-white"
            onClick={downloadAllExcel}
          >
            Download Report
          </ReactBootstrap.Button>
        </div>

        <ReactBootstrap.Table className="mt-4" striped bordered hover size="sm">
          <thead className="text-center">
            <tr>
              <th>Appraisal ID</th>
              <th>Emp.ID</th>
              <th>Emp.Name</th>
              <th>Emp.score</th>
              <th>App.status</th>
              <th>Department</th>
              <th>Emp.Grade</th>
              <th>Assessor Name</th>
              <th>Approver Name</th>
              <th>Appraisal Date</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.map((reports, index) => (
              <tr key={index}>
                <td>{reports.AppraisalForm}</td>
                <td>{reports.EmployeeID}</td>
                <td>{reports.EmployeeName}</td>
                <td>{reports.EmployeeScore}</td>
                <td>{reports.AppraisalStatus}</td>
                <td>{reports.Department}</td>
                <td>{reports.EmployeeGrade}</td>
                <td>{reports.AssessorName}</td>
                <td>{reports.Approver}</td>
                <td>{formatDate(reports.AppraisalStartDate)}</td>
              </tr>
            ))}
          </tbody>
        </ReactBootstrap.Table>

        <ReactBootstrap.Pagination>
          {Array.from(
            { length: Math.ceil(filteredPosts.length / postsPerPage) },
            (_, index) => (
              <ReactBootstrap.Pagination.Item
                key={index}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </ReactBootstrap.Pagination.Item>
            )
          )}
        </ReactBootstrap.Pagination>
      </div>
    );

  if (path === "/kpireports")
    return (
      <div className="pb-3">
        <h4 className="text-start">Download {reportTitle} Reports</h4>
        {/* <div className='col-lg-12 d-flex'>
                    <lable className='col-lg-4'>Start Date(Optional)</lable>
                    <lable  className='col-lg-4'>End Date(Optional)</lable>
                    <lable  className='col-lg-4'>Department (Optional)</lable>
                  </div>
                <div className='col-lg-12 d-flex mt-2 pb-3'>
                   <input
                    id="startdt"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="form-control-my"
                            placeholder='Start Date'
                        />
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="form-control-my"
                        />
                         <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search by Employee ID or Name"
                            className="form-control-my"
                        />


                </div> */}

        {/* <div className='col-lg-12 d-flex justify-content-start'>

                        <input
                        type="text"
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value)}
                        placeholder="Search by Department"
                        className="form-control-my"
                         />

                <ReactBootstrap.Button variant="" className="ml-2 p-0 w-25 bg-danger text-white" onClick={downloadAllExcel}>KPI Report</ReactBootstrap.Button>
                    </div> */}

        <div className="col-lg-12 d-flex"></div>
        <div className="col-lg-12 d-flex mt-2 pb-3"></div>

        <div className="col-lg-12 d-flex justify-content-start">
          <ReactBootstrap.Button
            variant=""
            className="ml-2 p-0 w-25 bg-danger text-white"
            onClick={downloadToExcel}
          >
            KPI Report
          </ReactBootstrap.Button>
        </div>

        <ReactBootstrap.Table className="mt-4" striped bordered hover size="sm">
          <thead className="text-center">
            <tr>
              <th>S.No</th>
              <th>KPI Title</th>
              <th>Sub KPI</th>
              <th>Department</th>
              <th> Start Date</th>
              <th> End Date</th>
              <th> Assignees</th>
              <th> Progress</th>
            </tr>
          </thead>
          <tbody>
            {posts.reports.map((reports, index) => (
              <tr key={index}>
                {/* <td>{reports.SlNo}</td> */}
                {/* <td>{index + 1}</td> */}
                <td>{(currentPage - 1) * 20 + index + 1}</td>
                <td>{reports.kpi}</td>
                <td>{reports.subkpi}</td>
                <td>{reports.departmentname}</td>
                <td>{formatDate(reports.startdate)}</td>
                <td>{formatDate(reports.enddate)}</td>

                <td>{reports.assignees}</td>
                <td>{reports.progress}</td>
              </tr>
            ))}
            {currentPosts == null ? (
              <tr>
                <td>No KPI Data</td>
              </tr>
            ) : (
              ""
            )}
          </tbody>
        </ReactBootstrap.Table>

        <ReactBootstrap.Pagination>
          <ReactBootstrap.Pagination.First
            onClick={handlePrevGroup}
            disabled={pageGroupStart === 1}
          />
          <ReactBootstrap.Pagination.Prev
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          />

          {currentPageNumbers.map((page) => (
            <ReactBootstrap.Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => paginate(page)}
            >
              {page}
            </ReactBootstrap.Pagination.Item>
          ))}

          <ReactBootstrap.Pagination.Next
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPageCount}
          />
          <ReactBootstrap.Pagination.Last
            onClick={handleNextGroup}
            disabled={pageGroupStart + pagesPerGroup > totalPageCount}
          />
        </ReactBootstrap.Pagination>

        {/* <ReactBootstrap.Pagination>
          {Array.from(
            { length: Math.ceil(filteredPosts.length / postsPerPage) },
            (_, index) => (
              <ReactBootstrap.Pagination.Item
                key={index}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </ReactBootstrap.Pagination.Item>
            )
          )}
        </ReactBootstrap.Pagination> */}
      </div>
    );
  if (path === "/kpioverall")
    return (
      <div className="pb-3">
        {/* <h4 className="text-start">{reportTitle} Reports</h4> */}
        <h4 className="text-start">Kpi Overall Reports</h4>
        <div className="col-lg-12 d-flex"></div>
        <div className="col-lg-12 d-flex mt-2 pb-3"></div>

        <div className="col-lg-12 d-flex justify-content-start">
          <ReactBootstrap.Button
            variant=""
            className="ml-2 p-0 w-25 bg-danger text-white"
            onClick={downloadToExcel}
          >
            Overall KPI Report
          </ReactBootstrap.Button>
        </div>

        <ReactBootstrap.Table className="mt-4" striped bordered hover size="sm">
          <thead className="text-center">
            <tr>
              <th>S.No</th>
              <th>Employee Name</th>

              <th>Department</th>
              <th>Total No. of KPI</th>
              <th>Completed KPI</th>
              <th>Pending KPI</th>
            </tr>
          </thead>
          <tbody>
            {posts.reports.map((reports, index) => (
              <tr key={index}>
                <td>{reports.sno}</td>
                <td>{reports.fullname}</td>

                <td>{reports.departmentname}</td>
                <td>{reports.kpitotal}</td>

                <td>{reports.completedkpi}</td>
                <td>{reports.pendingkpi}</td>
              </tr>
            ))}
          </tbody>
        </ReactBootstrap.Table>

        <ReactBootstrap.Pagination>
          <ReactBootstrap.Pagination.First
            onClick={handlePrevGroup}
            disabled={pageGroupStart === 1}
          />
          <ReactBootstrap.Pagination.Prev
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          />

          {currentPageNumbers.map((page) => (
            <ReactBootstrap.Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => paginate(page)}
            >
              {page}
            </ReactBootstrap.Pagination.Item>
          ))}

          <ReactBootstrap.Pagination.Next
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPageCount}
          />
          <ReactBootstrap.Pagination.Last
            onClick={handleNextGroup}
            disabled={pageGroupStart + pagesPerGroup > totalPageCount}
          />
        </ReactBootstrap.Pagination>

        {/* <ReactBootstrap.Pagination>
          {Array.from(
            { length: Math.ceil(filteredPosts.length / postsPerPage) },
            (_, index) => (
              <ReactBootstrap.Pagination.Item
                key={index}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </ReactBootstrap.Pagination.Item>
            )
          )}
        </ReactBootstrap.Pagination> */}
      </div>
    );
  if (path === "/reappraisal")
    return (
      <div className="pb-3">
        <h4 className="text-start">{reportTitle} Reports</h4>
        <div className="col-lg-12 d-flex mt-2 pb-3">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="form-control-my"
          />

          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search by Employee ID or Name"
            className="form-control-my"
          />
        </div>

        <div className="col-lg-12 d-flex justify-content-end">
          <input
            type="text"
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            placeholder="Search by Department"
            className="form-control-my"
          />
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="form-control-my p-1"
          >
            <option value="">All Appraisal Statuses</option>
            {Array.from(
              new Set(posts.reports.map((report) => report.AppraisalStatus))
            ).map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
          <ReactBootstrap.Button
            variant=""
            className="ml-2 p-0 w-25 bg-danger text-white"
            onClick={downloadAllExcel}
          >
            All Reports
          </ReactBootstrap.Button>
        </div>

        <ReactBootstrap.Table className="mt-4" striped bordered hover size="sm">
          <thead className="text-center">
            <tr>
              <th>Appraisal ID</th>
              <th>Emp.ID</th>
              <th>Emp.Name</th>
              <th>Emp.score</th>
              <th>App.status</th>
              <th>Department</th>
              <th>Emp.Grade</th>
              <th>Assessor Name</th>
              <th>Approver Name</th>
              <th>Appraisal Date</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.map((reports, index) => (
              <tr key={index}>
                <td>{reports.AppraisalForm}</td>
                <td>{reports.EmployeeID}</td>
                <td>{reports.EmployeeName}</td>
                <td>{reports.EmployeeScore}</td>
                <td>{reports.AppraisalStatus}</td>
                <td>{reports.Department}</td>
                <td>{reports.EmployeeGrade}</td>
                <td>{reports.AssessorName}</td>
                <td>{reports.Approver}</td>
                <td>{formatDate(reports.AppraisalStartDate)}</td>
              </tr>
            ))}
          </tbody>
        </ReactBootstrap.Table>

        <ReactBootstrap.Pagination>
          {Array.from(
            { length: Math.ceil(filteredPosts.length / postsPerPage) },
            (_, index) => (
              <ReactBootstrap.Pagination.Item
                key={index}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </ReactBootstrap.Pagination.Item>
            )
          )}
        </ReactBootstrap.Pagination>
      </div>
    );

  if (path === "/pipdev")
    return (
      <div className="pb-3">
        <h4 className="text-start">{reportTitle} Reports</h4>
        <div className="col-lg-12 d-flex"></div>
        <div className="col-lg-12 d-flex mt-2 pb-3"></div>

        <div className="col-lg-12 d-flex justify-content-start">
          <ReactBootstrap.Button
            variant=""
            className="ml-2 p-0 w-25 bg-danger text-white"
            onClick={downloadAllExcel}
          >
            Dowload Report
          </ReactBootstrap.Button>
        </div>

        <ReactBootstrap.Table className="mt-4" striped bordered hover size="sm">
          <thead className="text-center">
            <tr>
              <th>S.No</th>
              <th>Employee Name</th>
              <th>Manager Name</th>

              <th>Date raised</th>

              <th>PIP Status</th>
              <th>HR Approval</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.map((reports, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{reports.employee_fullname}</td>
                <td>{reports.manager_fullname}</td>

                <td>{reports.date_raised}</td>
                <td>{reports.status}</td>
                <td>{reports.hr_approver_fullname}</td>
              </tr>
            ))}
            {currentPosts == null ? (
              <tr>
                <td>No PIP Data</td>
              </tr>
            ) : (
              ""
            )}
          </tbody>
        </ReactBootstrap.Table>

        <ReactBootstrap.Pagination>
          {Array.from(
            { length: Math.ceil(filteredPosts.length / postsPerPage) },
            (_, index) => (
              <ReactBootstrap.Pagination.Item
                key={index}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </ReactBootstrap.Pagination.Item>
            )
          )}
        </ReactBootstrap.Pagination>
      </div>
    );
  if (path === "/awardsreport")
    return (
      <div className="pb-3">
        <h4 className="text-start">{reportTitle} Reports</h4>
        <div className="col-lg-12 d-flex"></div>
        <div className="col-lg-12 d-flex mt-2 pb-3"></div>

        <div className="col-lg-12 d-flex justify-content-start">
          <ReactBootstrap.Button
            variant=""
            className="ml-2 p-0 w-25 bg-danger text-white"
            onClick={downloadAllExcel}
          >
            Download Report
          </ReactBootstrap.Button>
        </div>

        <ReactBootstrap.Table className="mt-4" striped bordered hover size="sm">
          <thead className="text-center">
            <tr>
              <th>S.No</th>
              <th>Employee Name</th>
              <th>Award Title</th>
              <th>Month/Year</th>
              <th>Recomended By</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.map((reports, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{reports.employee_name}</td>
                <td>{reports.departmentname}</td>
                <td>{reports.award_name}</td>
                <td>{reports.month_year}</td>

                <td>{reports.recommended_by_name}</td>
              </tr>
            ))}
          </tbody>
        </ReactBootstrap.Table>

        <ReactBootstrap.Pagination>
          {Array.from(
            { length: Math.ceil(filteredPosts.length / postsPerPage) },
            (_, index) => (
              <ReactBootstrap.Pagination.Item
                key={index}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </ReactBootstrap.Pagination.Item>
            )
          )}
        </ReactBootstrap.Pagination>
      </div>
    );
};

export default ReportTable;
